import { render, staticRenderFns } from "./last.vue?vue&type=template&id=a0c11ae2&scoped=true"
import script from "./last.vue?vue&type=script&lang=js"
export * from "./last.vue?vue&type=script&lang=js"
import style0 from "./last.vue?vue&type=style&index=0&id=a0c11ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c11ae2",
  null
  
)

export default component.exports